import React, { Component } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import { Student } from '@app/models/users'
import logo from '@src/images/icons/brics-logo-passwords'

const Learner = ({ student }) => {
  return (
    <div className="password-printer__block">
      <div className="password-printer__column password-printer__column-name">
        <div className="password-printer__cell password-printer__name">
          { window.COUNTRY === 'IN' ?
             `${student.name} ${student.surname}` : student.fullName
          }
        </div>
        <div className="password-printer__cell password-printer__logo">
          <img src={logo} />
        </div>
      </div>
      <div className="password-printer__column">
        <div className="password-printer__cell">
          <span className="password-printer__label">
            { I18n.t('groups.passwords.login') }
            :
          </span>
          &nbsp;

          <span className="password-printer__label-lg">
            { student.login }
          </span>
        </div>
        <div className="password-printer__cell">
          <span className="password-printer__label">
            { I18n.t('groups.passwords.password') }
            :
          </span>
          &nbsp;

          <span className="password-printer__label-lg">
            { student.password }
          </span>
        </div>
        <div className="password-printer__info">
          <p className="password-printer__info-label">&nbsp;</p>
          <p className="password-printer__info-label">&nbsp;</p>
        </div>
      </div>
    </div>
  )
}

const Page = ({ page, index, pageBreak }) => {
  let classes = classnames(
    "password-printer__page",
    {
      "page-break": pageBreak
    }
  )

  return (
    <div className={classes}>
      {
        _.map(page, (student) => {
          return <Learner student={student} key={`student_${student.id}`} />
        })
      }
    </div>
  )
}

class PasswordPrinter extends Component {
  render() {
    const { students } = this.props
    const pages = _.chunk(students, 8)

    return (
      <div className="password-printer">
        {
          _.map(pages, (page, index) => {
            const pageBreak = index !== pages.length - 1
            return (
              <Page key={index}
                page={page}
                pageBreak={pageBreak}
                index={index}
              />
            )
          })
        }
      </div>
    )
  }
}

export default PasswordPrinter
